module.exports = __webpack_public_path__ + "img/2-9.a757f917.svg";